// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"style_machineIcon__3nsjB","machineImage":"style_machineImage__3hYE2"};